import { Language } from '@coolblue-development/constants';
import { convertDatePartsToObject, getLocale } from '../helpers.js';
/**
 * function: formatFullDate
 * Pattern: FullDateFormat
 * Example: 19 januari 2016
 *
 * Variations in PHP
 * nl_NL: 'd MMMM y'
 * fr_BE: 'd MMMM y'
 * en_US: 'd MMMM y'
 * de_DE: 'd. MMMM y'
 */
export function formatFullDate({ date = new Date(), language, subsidiary, }) {
    const locale = getLocale(language, subsidiary);
    const dateFormat = new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    const parts = dateFormat.formatToParts(date);
    const { day, month, year } = convertDatePartsToObject(parts);
    if (language === Language.GERMAN) {
        return `${day}. ${month} ${year}`;
    }
    return `${day} ${month} ${year}`;
}
//# sourceMappingURL=formatFullDate.js.map